export default "__VITE_ASSET__BdhhpcKp__"